import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Breadcrumb } from 'react-breadcrumbs'
import { Grid, Row, Col } from 'react-bootstrap'
import { get } from 'lodash'
import { withRouter } from 'react-router-dom'

import PinUserIcon from 'Assets/Images/icons/pinUser'
import { PATHS } from 'Config/Routing/paths'

import { AmbassadorContactDetailsForm } from './../../../../../Containers/Form/City/Ambassador/ContactDetails'
import { AmbassadorWrapper } from 'Components/City/Page/Ambassador/AmbassadorWrapper'
import { AmbassadorSection } from 'Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { PageTitle } from 'Components/PageTitle'

import {
  getAmbassadorByIdGraphQL,
  updateAmbassadorById,
} from 'Reducers/Ambassador/actions'
import { getCities } from 'Reducers/City/actions'
import { uploadProfileImage } from 'Reducers/Upload/actions'

class AmbassadorEdit extends Component {
  constructor(props) {
    super(props)

    this.ambassadorContactDetailsFormSubmitHandler = this.ambassadorContactDetailsFormSubmitHandler.bind(
      this,
    )
    this.ambassadorContactDetailsFormSubmitSuccessHandler = this.ambassadorContactDetailsFormSubmitSuccessHandler.bind(
      this,
    )
  }

  componentDidMount() {
    const ambassadorId = this.props.match.params.ambassadorId
    this.props.getCities()
    this.props.getAmbassadorById(ambassadorId)
  }

  render() {
    return (
      <AmbassadorWrapper>
        <Breadcrumbs icon={<PinUserIcon style={{ width: 16 }} />} />
        <Breadcrumb
          data={{ title: 'Dashboard', pathname: `${PATHS.main.dashboard}` }}
        />
        <Breadcrumb
          data={{
            title: 'Cities',
            pathname: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
          }}
        />
        <Breadcrumb
          data={{
            title: 'Edit Brand Ambassadors',
            pathname: this.props.match.url,
          }}
        />
        <PageTitle>
          {this.props.ambassador.firstName} {this.props.ambassador.lastName}
          {this.props.ambassador.status && (
            <span className="status">({this.props.ambassador.status})</span>
          )}
        </PageTitle>

        {this.renderAmbassadorSections()}
      </AmbassadorWrapper>
    )
  }

  /**
   * Render ambassador sections
   *
   * @returns JSX.Element[]
   *
   */
  renderAmbassadorSections() {
    const { ambassador } = this.props

    return <div>{this.renderAmbassadorContactDetailsSection(ambassador)}</div>
  }

  /**
   * Render ambassador contact details section
   *
   * @returns JSX.Element[]
   *
   */
  renderAmbassadorContactDetailsSection() {
    return (
      <AmbassadorSection>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <SectionTitle>Contact Details</SectionTitle>
            </Col>
          </Row>
          <AmbassadorContactDetailsForm
            cities={this.props.cities}
            onSubmit={this.ambassadorContactDetailsFormSubmitHandler}
          />
        </Grid>
      </AmbassadorSection>
    )
  }

  ambassadorContactDetailsFormSubmitHandler(values) {
    const { updateAmbassadorById, uploadProfileImage } = this.props
    const { ambassadorId } = this.props.match.params

    const callbacks = {
      onSuccess: this.ambassadorContactDetailsFormSubmitSuccessHandler,
    }

    const payload = imageUrl => ({
      first_name: values.firstName,
      last_name: values.lastName,
      mobile_phone: values.mobilePhone,
      city_id: values.cityId,
      business_number: values.abn,
      profile_picture: imageUrl,
    })

    const imageFile = get(values, 'profilePicture[0]')
    if (imageFile && imageFile.type) {
      uploadProfileImage(ambassadorId, imageFile, {
        onSuccess: imageUrl => {
          updateAmbassadorById(ambassadorId, payload(imageUrl), callbacks)
        },
      })
    } else {
      updateAmbassadorById(ambassadorId, payload(), callbacks)
    }
  }

  ambassadorContactDetailsFormSubmitSuccessHandler() {
    const { history } = this.props
    const { ambassadorId } = this.props.match.params
    const cityId = this.props.match.params.id

    history.push(
      `${PATHS.main.dashboard}${
        PATHS.dashboard.cities
      }/${cityId}/ambassadors/${ambassadorId}`,
    )
  }
}

AmbassadorEdit.propTypes = {
  ambassador: PropTypes.object.isRequired,
  getAmbassadorById: PropTypes.func.isRequired,
  updateAmbassadorById: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  ambassador: state.ambassadors.ambassadorById,
  cities: state.city.citiesList,
})

export default connect(
  mapStateToProps,
  {
    getAmbassadorById: getAmbassadorByIdGraphQL,
    getCities,
    updateAmbassadorById,
    uploadProfileImage,
  },
)(withRouter(AmbassadorEdit))



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Edit/index.js